// extracted by mini-css-extract-plugin
export default {"navigation":"map_navigation__kjMdk","select":"map_select__XsYR9"};